module.exports = __webpack_public_path__ + "static/media/logo-phone-by-webcom-loader.bfa6adf2.svg";